import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    HostListener,
    Renderer2,
    AfterViewInit,
} from '@angular/core';

@Component({
    selector: 'fi-device-switch',
    templateUrl: './device-switch.component.html',
    styleUrls: ['./device-switch.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-device-switch' },
    standalone: false,
})
export class DeviceSwitchComponent implements AfterViewInit {
    @Input() device: number = 800;
    @Output() deviceChange = new EventEmitter<number>();

    @Input() deviceMaxWidth: number = 800;
    @Input() switchTitle;
    @Input() showDeviceIcons: boolean = false;
    @Input() targetElement: HTMLElement;

    readonly deviceMinWidth: number = 320;

    constructor(private renderer: Renderer2) {}

    change(event) {
        this.device = event.value;
        this.deviceChange.emit(this.device);
        this.updateTargetSize();
    }

    ngAfterViewInit(): void {
        this.updateTargetSize();
    }

    @HostListener('document:resize')
    updateTargetSize() {
        if (this.targetElement) {
            const el = this.targetElement,
                r = this.renderer;
            r.setStyle(el, 'max-width', this.device + 'px');

            if (this.device <= 768) {
                r.addClass(el, 'fi-device-size-break-mobile');
            } else {
                r.removeClass(el, 'fi-device-size-break-mobile');
            }

            if (this.device <= 450) {
                r.addClass(el, 'fi-device-size-break-mobile-small');
            } else {
                r.removeClass(el, 'fi-device-size-break-mobile-small');
            }
        }
    }
}
